module.exports = __webpack_public_path__ + "img/template4.80c24718.png";